var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91769 3.17914C2.66735 3.17914 3.2807 2.56579 3.2807 1.81613C3.2807 1.06648 2.66735 0.453125 1.91769 0.453125C1.16804 0.453125 0.554688 1.06648 0.554688 1.81613C0.554688 2.56579 1.16804 3.17914 1.91769 3.17914ZM1.91769 4.54215C1.16804 4.54215 0.554688 5.1555 0.554688 5.90515C0.554688 6.65481 1.16804 7.26816 1.91769 7.26816C2.66735 7.26816 3.2807 6.65481 3.2807 5.90515C3.2807 5.1555 2.66735 4.54215 1.91769 4.54215ZM1.91769 8.63117C1.16804 8.63117 0.554688 9.24452 0.554688 9.99417C0.554688 10.7438 1.16804 11.3572 1.91769 11.3572C2.66735 11.3572 3.2807 10.7438 3.2807 9.99417C3.2807 9.24452 2.66735 8.63117 1.91769 8.63117Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionVertical);
export default __webpack_public_path__ + "static/media/actionVertical.04622dd2d47c75bb7f47d135f93ad9e3.svg";
export { ForwardRef as ReactComponent };